var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 19,
    viewBox: "0 0 12 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 7.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-31_25_",
    d: "M8.03418 18.3264L8.03418 6.33816",
    stroke: "url(#paint0_linear_1_826)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-31_25__2",
    d: "M11.3037 18.3264L11.3037 3.06864",
    stroke: "url(#paint1_linear_1_826)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-31_26_",
    d: "M4.76514 18.3264L4.76514 9.60769",
    stroke: "url(#paint2_linear_1_826)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-31_27_",
    d: "M1.49512 18.3264L1.49512 11.7874",
    stroke: "url(#paint3_linear_1_826)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 8.24043L8.24043 1",
    stroke: "url(#paint4_linear_1_826)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_826",
    x1: 8.19159,
    y1: 11.7329,
    x2: 6.41832,
    y2: 11.7282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD749B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281AC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_826",
    x1: 11.1463,
    y1: 9.93464,
    x2: 12.9196,
    y2: 9.93093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD749B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281AC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_826",
    x1: 4.60773,
    y1: 13.5311,
    x2: 6.38098,
    y2: 13.5246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD749B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281AC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_826",
    x1: 1.33771,
    y1: 14.7299,
    x2: 3.11094,
    y2: 14.7213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD749B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281AC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_826",
    x1: 4.98223,
    y1: -0.139697,
    x2: 5.39073,
    y2: 12.6866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD749B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281AC8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.c522b7bcd4efb2f0724c8aa4f748768d.svg";
export { ForwardRef as ReactComponent };